import { Scale, TrendingUp, Calendar } from "lucide-react";

interface MetricEntry {
  id: string;
  date: string;
  weight: number;
  arm?: number;
  waist?: number;
  abdomen?: number;
  hip?: number;
  thigh?: number;
  calf?: number;
  note?: string;
  photoIds?: string[];
}

interface Props {
  latestEntry: MetricEntry;
  weightDiff: string | null;
  totalEntries: number;
}

const MetricsSummaryCards = ({ latestEntry, weightDiff, totalEntries }: Props) => (
  <div className="grid grid-cols-3 gap-3">
    <div className="bg-card rounded-xl p-4 shadow-card border border-border text-center">
      <Scale className="w-5 h-5 text-primary mx-auto mb-1" />
      <p className="text-lg font-bold text-foreground">{latestEntry.weight} kg</p>
      <p className="text-xs text-muted-foreground">Peso atual</p>
    </div>
    <div className="bg-card rounded-xl p-4 shadow-card border border-border text-center">
      <TrendingUp className="w-5 h-5 text-primary mx-auto mb-1" />
      <p className={`text-lg font-bold ${weightDiff && Number(weightDiff) < 0 ? "text-primary" : weightDiff && Number(weightDiff) > 0 ? "text-destructive" : "text-foreground"}`}>
        {weightDiff ? `${Number(weightDiff) > 0 ? "+" : ""}${weightDiff}` : "—"} kg
      </p>
      <p className="text-xs text-muted-foreground">Variação</p>
    </div>
    <div className="bg-card rounded-xl p-4 shadow-card border border-border text-center">
      <Calendar className="w-5 h-5 text-primary mx-auto mb-1" />
      <p className="text-lg font-bold text-foreground">{totalEntries}</p>
      <p className="text-xs text-muted-foreground">Registros</p>
    </div>
  </div>
);

export default MetricsSummaryCards;
export type { MetricEntry };
